<div class="diagnostic-window-popover">
    <div class="popover-header">
        <button
            mat-icon-button
            class="popover-close"
            (click)="closePopover.emit()"
        >
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <app-diagnostic-window-card
        [locationName]="locationName"
        [window]="window"
        [nextExpectedDiagnosticSession]="nextExpectedDiagnosticSession"
        [customerDateFormat]="customerDateFormat"
        (edit)="edit.emit()"
        (deleteWindow)="deleteWindow.emit()"
    ></app-diagnostic-window-card>
</div>
